import { TOptions } from '@if/core/i18n'
import { translateErrorCode } from '@src/types'
import { forwardRef } from 'react'
import { FieldError } from 'react-hook-form'
import { IMaskInput, ReactElementProps } from 'react-imask'

export type NumberInputProps = {
  onChange: (event: { target: { name: string; value: number | null } }) => void
  name: string
  disableDecimals?: boolean
  enableNegative?: boolean
  value?: number | string | null
  error?: FieldError
  label?: string
  errorParams?: TOptions
  wrapStyle?: string
  id: string
} & Omit<ReactElementProps<HTMLInputElement>, 'onChange'>

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(function NumberInput(props, ref) {
  const {
    onChange,
    name,
    error,
    label,
    disableDecimals = false,
    id,
    wrapStyle,
    errorParams,
    enableNegative = false,
    value,
    ...other
  } = props
  return (
    <div className={`control-group ${error && 'error'}`}>
      {label && <label htmlFor={id}>{label}</label>}
      <div className={wrapStyle}>
        <IMaskInput
          id={id}
          type="text"
          {...other}
          mask={Number}
          thousandsSeparator=""
          radix="."
          mapToRadix={[',', '.']}
          unmask={true}
          inputRef={ref}
          value={value !== undefined ? (value !== null ? value.toString() : '') : undefined}
          onAccept={(value) => {
            onChange({ target: { name, value: value === '' ? null : Number(value) } })
          }}
          scale={disableDecimals ? 0 : 2}
          padFractionalZeros={!disableDecimals}
          min={enableNegative ? Number.MIN_SAFE_INTEGER : 0}
          normalizeZeros
        />
      </div>
      {error && <p className="error-message">{translateErrorCode(error, errorParams)}</p>}
    </div>
  )
})

export default NumberInput
